import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { PublicFolder } from '../../-components/public-folder'
import { linkAccess } from '../../-lib/access'
import { publicLinkQueryOptions } from '../../-query/query-options'

/**
 * A folder below a folder link's own, by id, so a reload and the browser's
 * back button land where the visitor was.
 *
 * The id is only an address: the server answers the same «not available» for
 * a folder above the link's, beside it or in another link, and this page
 * draws what the server answers.
 */
export const Route = createFileRoute('/s/$token/f/$nodeId/')({
	component: PublicLinkFolder
})

function PublicLinkFolder() {
	const { token, nodeId } = Route.useParams()
	const access = linkAccess(useQuery(publicLinkQueryOptions(token)))

	if (access.state !== 'open') {
		return null
	}

	return (
		<div className='flex min-h-0 flex-1 flex-col'>
			<PublicFolder
				key={nodeId}
				link={access.link}
				nodeId={nodeId}
				token={token}
			/>
		</div>
	)
}
